import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PortalDropdown from '../../../portal/portalDropdown'

@inject('windowsDomainsStore', 'translationsStore') @observer
export default class DomainsDropdownContainer extends Component {
  
  componentDidMount() {

    this.props.windowsDomainsStore.getAllDomains();
  }

  render() {

    if (this.props.windowsDomainsStore.domains == undefined) {
      
      return null;
    }

    let list = [];

    list.push({
        id: -1,
        name: this.props.translationsStore.translate('SELECT_DOMAIN')
    });
  
    this.props.windowsDomainsStore.domains.forEach(domain => {
        
        list.push(domain);
    });
   
    
    return (
        <PortalDropdown
            {...this.props}
            hintText={this.props.hintText}
            floatingLabelText={this.props.floatingLabelText}
            width={this.props.width}
            disabled={this.props.disabled}
            onChange={this.props.onChange}
            errorText={this.props.errorText}
            value={this.props.value}
            helpTooltipText={this.props.helpTooltipText}
            items={list}
        />
    );
  }
}